export default class EnterpriseUpdateRequest {
  public name: string;
  public email: string;
  public quota: number;
  public smsQuota: number;
  public identityRequestQuota: number;
  public seats: number;
  public allocated: number;
  public payg: boolean;
  public owner;
  public limits;

  constructor(options) {
    this.name = options.name;
    this.email = options.email;
    this.quota = options.quota;
    this.smsQuota = options.smsQuota;
    this.identityRequestQuota = options.identityRequestQuota;
    this.seats = options.seats;
    this.allocated = options.allocated;
    this.payg = options.payg;
    this.owner = {
      sCustomerId: options.owner.sCustomerId,
      subscriptionId: options.owner.subscriptionId,
      kind: options.owner.kind,
      trialComplete: options.owner.trialComplete,
      subscriptionInterval: options.owner.subscriptionInterval,
      quotaRenewedOn: options.owner.quotaRenewedOn,
      annualCommitmentMonthlyBilling: options.owner.annualCommitmentMonthlyBilling,
    };
    if (options.limits) {
      this.limits = {
        documentSize: options.limits.documentSize,
      };
    }
  }
}
